<ppl-accordion [title]="'Approved Authorizations'" [isOpen]="true" *authorize="[pageId, tabId, 'Authorization', 'section']">
    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="approvedData"
            [disableSelection]="true" [cols]="approvedCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtonsApproved">
        </ppl-list-table>
    </div>
    }@else {
    <ul class="paystub-list">
        <li class="paystub-item">
            <div>
                <div class="paystub-date">September 20, 2024</div>
                <div class="paystub-amount">$1,200.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">August 20, 2024</div>
                <div class="paystub-amount">$1,150.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">July 20, 2024</div>
                <div class="paystub-amount">$1,175.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">June 20, 2024</div>
                <div class="paystub-amount">$1,125.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
    </ul>
    }
</ppl-accordion>
<ppl-accordion [title]="'Errored Out Authorizations'" [isOpen]="true" *authorize="[pageId, tabId, 'Authorization', 'section']">

    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="erroredOutData"
            [disableSelection]="true" [cols]="erroredCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtonsErrored">
        </ppl-list-table>
    </div>
    }@else {
    <ul class="paystub-list">
        <li class="paystub-item">
            <div>
                <div class="paystub-date">September 20, 2024</div>
                <div class="paystub-amount">$1,200.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">August 20, 2024</div>
                <div class="paystub-amount">$1,150.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">July 20, 2024</div>
                <div class="paystub-amount">$1,175.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">June 20, 2024</div>
                <div class="paystub-amount">$1,125.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
    </ul>
    }
</ppl-accordion>
<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
       <ppl-authorization-details [pageSource]="pageSource"></ppl-authorization-details>
    </ng-template>
</div>